enum BillingAnniversaryFilterType {
  NONE = 'NONE',
  HAS_BILLING_ON_ANNIVERSARY = 'HAS_BILLING_ON_ANNIVERSARY',
  NOT_HAS_BILLING_ON_ANNIVERSARY = 'NOT_HAS_BILLING_ON_ANNIVERSARY',
}

const billingAnniversarFilterTypeOptions = [
  { text: 'Todos', value: BillingAnniversaryFilterType.NONE },
  { text: 'Sim', value: BillingAnniversaryFilterType.HAS_BILLING_ON_ANNIVERSARY },
  { text: 'Não', value: BillingAnniversaryFilterType.NOT_HAS_BILLING_ON_ANNIVERSARY },
];

export {
  BillingAnniversaryFilterType,
  billingAnniversarFilterTypeOptions,
}
